import { InteractionRequiredAuthError } from '@azure/msal-browser'

import { loginRequest } from '../config/MsalConfig'

/** 

 * Valid SDF user roles that grant access to the application 

 */

/** 

 * Checks if the user has authorization to access the application 

 * @param {PublicClientApplication} msal - MSAL instance 

 * @returns {boolean} True if user has at least one valid role, false otherwise 

 */

export function checkUserAuthorization(msal) {
  const activeAccount = msal.getActiveAccount()

  if (!activeAccount) {
    return false
  }

  const userRoles = activeAccount?.idTokenClaims?.roles || []

  // Check if user has at least one valid SDF role

  return userRoles
}

/** 

 * Ensures user is signed in and returns an access token 

 * Handles SSO silently if session exists, otherwise redirects to login 

 * @param {PublicClientApplication} msal - MSAL instance 

 * @returns {Promise<string>} Access token 

 */

export async function ensureSignedInAndGetToken(msal) {
  // Check for autologin parameter in URL (e.g., /?autologin=1#/control)

  const urlParams = new URLSearchParams(window.location.search)

  const autologin = urlParams.get('autologin')

  // Handle redirect responses (important for login/token acquisition flows)

  const redirectResult = await msal.handleRedirectPromise()

  // If redirect returned an account, set it as active

  if (redirectResult?.account) {
    msal.setActiveAccount(redirectResult.account)
  }

  // Pick an existing account if any

  const activeAccount = msal.getActiveAccount() ?? msal.getAllAccounts()[0] ?? null

  if (!activeAccount) {
    // No cached account -> start login redirect

    // If SSO session exists, Azure AD will redirect back without showing login UI

    if (autologin) {
      await msal.loginRedirect(loginRequest)
    }

    // loginRedirect will navigate away; return won't happen now

    throw new Error('Redirecting to login...')
  }

  // Try to acquire token silently (SSO)

  try {
    const result = await msal.acquireTokenSilent({
      ...loginRequest,

      account: activeAccount,
    })

    return result.accessToken
  } catch (err) {
    // If silent fails because interaction is required (Conditional Access, expired session, etc.)

    if (err instanceof InteractionRequiredAuthError) {
      await msal.acquireTokenRedirect({
        ...loginRequest,

        account: activeAccount,
      })

      throw new Error('Redirecting to acquire token...')
    }

    throw err
  }
}
